<template>
  <a-layout>
    <a-layout-header class="layout-header">
      <img :src="layoutData.logo" />
    </a-layout-header>
    <a-layout-content style="background-color: #fff;">
      <router-view />
    </a-layout-content>
    <a-layout-footer class="layout-footer">
      <a-flex class="layout-footer-info" justify="space-between">
        <a-flex justify="flex-start" class="layout-footer-info-selection-container">
          <a-flex vertical v-for="(item, index) in layoutData.footer.selection" :key="index">
            <a-flex class="layout-footer-info-selection-title">{{item.title}}</a-flex>
            <a-flex vertical>
              <a-flex class="layout-footer-info-selection-sub" v-for="(sub, index) in item.sub"
                :key="`i_${index}`">{{sub.name}}</a-flex>
            </a-flex>
          </a-flex>
        </a-flex>
        <a-flex justify="flex-end" class="layout-footer-info-qr-code-container">
          <a-flex class="layout-footer-info-qr-code" vertical v-for="(item, index) in layoutData.footer.qrCode"
            :key="index">
            <img :src="item.image" />
            <span>{{item.name}}</span>
          </a-flex>
        </a-flex>
      </a-flex>
      <a-flex vertical class="layout-footer-service">
        <a-flex class="layout-footer-info-service-title">课程顾问</a-flex>
        <a-flex justify="space-between">
          <a-flex class="layout-footer-info-service-info" vertical v-for="(item, index) in layoutData.footer.service"
            :key="index">
            <a-flex class="layout-footer-info-service-info-name">
              {{item.name}}
            </a-flex>
            <a-flex>
              电话: {{item.mobile}}
            </a-flex>
            <a-flex>
              微信: {{item.wechat}}
            </a-flex>
          </a-flex>
        </a-flex>
      </a-flex>
      <a-flex class="layout-footer-filing" justify="center">
        版权所有：深圳市瀚思心能教育科技有限公司&emsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank">备案号：粤ICP备11089383号</a>&emsp;<a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502003278" target="_blank">粤公网安备
          44030502003278号</a>&emsp;最近更新日期：2026年08月02日
      </a-flex>
    </a-layout-footer>
  </a-layout>
</template>

<script setup>
  import {
    reactive
  } from 'vue'
  import store from '../store/index.js'

  const layoutData = reactive({
    logo: store.getters.mediaPath("layout/logo.png"),
    footer: {
      service: [{
        name: '吴老师',
        wechat: 'hansi-xiaolaoshi',
        mobile: '19925436843'
      }, {
        name: '张老师',
        wechat: '18126505415',
        mobile: '18126505415'
      }, {
        name: '魏老师',
        wechat: '19166210079',
        mobile: '19166210079'
      }],
      selection: [{
        title: "瀚思介绍",
        sub: [{
          name: "公司介绍"
        }, {
          nane: "联系我们"
        }, {
          name: "加入我们"
        }, {
          name: "最新动态"
        }]
      }, {
        title: "课程设置",
        sub: [{
          name: "心理咨询师基础班"
        }, {
          name: "心理咨询师执业班"
        }, {
          name: "心理学工作坊"
        }]
      }, {
        title: "心理咨询服务",
        sub: [{
          name: "企业EAP服务"
        }, {
          nane: "专业心理咨询"
        }, {
          name: "公益咨询"
        }, {
          name: "心理测评"
        }]
      }],
      qrCode: [{
        name: "瀚思-小程序",
        image: store.getters.mediaPath("layout/footer/mini_program.jpg")
      }, {
        name: "瀚思-订阅号",
        image: store.getters.mediaPath("layout/footer/subscription.jpg")
      }, {
        name: "心理咨询中心",
        image: store.getters.mediaPath("layout/footer/counseling.jpg")
      }]
    }
  })
</script>

<style lang="scss">
  .layout-header {
    width: 100%;
    padding-inline: 410px !important;
    display: flex;
    align-items: center;
    background: linear-gradient(90deg, rgba(227, 244, 251, 1) 0%, rgba(207, 244, 245, 1) 100%) !important;
    height: 120px !important;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .layout-header img {
    width: 344px;
    height: 60px;
  }

  .layout-footer {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  .layout-footer-info {
    width: 100%;
    padding-inline: 410px !important;
    background-color: rgba(0, 81, 199, 1);
    padding: 80px 0;
  }

  .layout-footer-service {
    width: 100%;
    padding-inline: 410px !important;
    background-color: rgba(0, 81, 199, 1);
    padding-bottom: 80px;
    color: #fff;
  }

  .layout-footer-info-service-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  .layout-footer-info-service-info {
    font-size: 24px;
    gap: 10px;
  }

  .layout-footer-info-service-info-name {
    font-weight: 700;
  }

  .layout-footer-info-selection-container {
    gap: 50px;
    color: #fff;
  }

  .layout-footer-info-selection-title {
    font-size: 32px;
    font-weight: 700;
  }

  .layout-footer-info-selection-sub {
    font-size: 20px;
    cursor: pointer;
    margin-top: 20px;
  }

  .layout-footer-info-selection-sub:hover {
    color: rgb(88, 160, 255);
  }

  .layout-footer-info-qr-code-container {
    gap: 50px;
  }

  .layout-footer-info-qr-code {
    padding: 20px;
    border: 1px #fff solid;
    border-radius: 20px;
  }

  .layout-footer-info-qr-code img {
    width: 150px;
    height: 150px;
  }

  .layout-footer-info-qr-code span {
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
    margin-top: 10px;
  }

  .layout-footer-filing {
    width: 100%;
    background-color: rgba(20, 43, 89, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    padding: 17px 0px;
  }

  .layout-footer-filing a {
    color: rgba(255, 255, 255, 1);
  }
</style>
